import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      isolation: 'isolate',
    },
    buttonClose: {
      position: 'absolute',
      top: 14,
      right: 8,
      padding: '10px',
      zIndex: 1,

      '& svg': {
        fontSize: theme.typography.pxToRem(11),
      },
    },
  }),
  { name: 'Popup' }
);
